import React from 'react';
import { AppBar, Toolbar, Box, Typography, useTheme, alpha } from '@mui/material';
import logo from '../assets/images/logo.png';
import UserMenuNavBar from './UserMenuNavBar';
import ApiStatusCircle from './apiStatusCircle';

interface iTopbar {
    isAuthenticated: boolean;
    auth: any;
}

const TopBar = (props: iTopbar) => {
    const theme = useTheme();

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                zIndex: theme.zIndex.drawer + 1,
                height: 56,
                backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${alpha(theme.palette.primary.light, 0.9)} 100%)`,
                backdropFilter: 'blur(8px)',
                borderBottom: `1px solid ${alpha('#fff', 0.08)}`,
            }}
        >
            <Toolbar
                sx={{
                    minHeight: '56px !important',
                    height: 56,
                    px: { xs: 1.5, sm: 2.5 },
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                {/* Logo + Brand */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                        component="img"
                        src={logo}
                        alt="Fermi"
                        sx={{
                            height: 36,
                            objectFit: 'contain',
                            filter: 'brightness(0) invert(1)',
                            opacity: 0.95,
                            transition: 'opacity 0.2s ease',
                            '&:hover': { opacity: 1 },
                        }}
                    />
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column' }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: '#fff',
                                fontWeight: 700,
                                letterSpacing: '0.02em',
                                lineHeight: 1.2,
                            }}
                        >
                            Fermi
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                color: alpha('#fff', 0.6),
                                fontSize: '0.65rem',
                                fontWeight: 500,
                                letterSpacing: '0.05em',
                            }}
                        >
                            Sistema Educacional
                        </Typography>
                    </Box>
                </Box>

                {/* Right side */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: 1.5,
                            px: 1,
                            py: 0.5,
                            transition: 'background-color 0.2s ease',
                            '&:hover': { bgcolor: alpha('#fff', 0.08) },
                        }}
                    >
                        <ApiStatusCircle />
                    </Box>
                    <UserMenuNavBar
                        isAuthenticated={props.isAuthenticated}
                        auth={props.auth}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
